import flatten from "lodash.flatten"

const createUploadUrlsOperation = "storage/CreateUploadUrls"

export const readFileContent = file => {
  return new Promise(resolve => {
    const reader = new FileReader()

    reader.onload = async (event) => {
      const content = event.target.result
      resolve(content)
    }

    reader.readAsArrayBuffer(file)
  })
}

export const createUploadUrl = async (request, isPublic, contentType) => {
  contentType = contentType.replace('+', '-')
  const parameters = { quantity: 1, contentType, isPublic }

  const { data: { urls } } = await request(createUploadUrlsOperation, parameters)
  const [ uploadUrl ] = urls

  return uploadUrl
}

export const upload = async (request, isPublic, contentType, body) => {
  const uploadUrl = await createUploadUrl(request, isPublic, contentType)

  const headers = { 'Content-Type': contentType }
  const options = { method: "PUT", body, headers }

  await fetch(uploadUrl, options)

  const [ url ] = uploadUrl.split('?')
  const [ path ] = uploadUrl.split('.com/')[1].split('?')

  const response = {
    url,
    path,
    isPublic
  }

  return response
}

export const getCustomUploadRequest = (request, isPublic) => {
  return async ({ file, onSuccess, onError }) => {
    const { type: contentType } = file

    const content = await readFileContent(file)

    let response
    try {
      response = await upload(request, isPublic, contentType, content)

    } catch (error) {
      return onError(error)
    }

    return onSuccess(response)
  }
}

/* note: map of mime types to files types based on mime types enum from storage spec */
export const MIME_TYPES_MAP = {
  "text/plain": ".txt",
  "image/jpeg": [".jpg", ".jpeg"],
  "image/png": ".png",
  "image/gif": ".gif",
  "image/svg+xml": ".svg",
  "image/heic": "heic",
  "application/zip": ".zip",
  "application/pdf": ".pdf",
  "application/msword": ".doc",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": ".docx",
  "application/vnd.ms-excel": ".xls",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ".xlsx",
  "application/vnd.ms-powerpoint": ".ppt",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": ".pptx",
}

export const FILE_TYPES = flatten(Object.values(MIME_TYPES_MAP))
